import React, {Suspense, useState} from 'react'
import {useImage} from 'react-image'
// import IconButton from "@mui/material/IconButton";
// import {CircularProgress, Dialog} from "@mui/material";
// import CloseIcon from '@mui/icons-material/Close';
// import {useDispatch, useSelector} from "react-redux";
// import {removeImageFromQuote} from "../reducers/cartSlice";
import fileDownload from "js-file-download";
import {Modal} from "react-bootstrap";
import {removeImage} from "../service/ImageService";

// import {startLoading, stopLoading} from "../reducers/loadingSlice";

function isImageFile(image_type) {
    // List of image extensions (add more if needed)
    const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "tiff", "webp", "svg"];
    return imageExtensions.includes(image_type);
}

function isVideoFile(image_type) {
    // List of image extensions (add more if needed)
    const videoFileExtensions = [
        "mp4",
        "avi",
        "x-msvideo",
        "x-matroska",
        "quicktime",
        "x-ms-wmv",
        "x-flv",
        "webm",
        "mpeg",
        "3gpp",
        "x-m4v",
        "vnd.rn-realmedia",
        "x-matroska",
        "vnd.dlna.mpeg-tts",
        "ogg",
    ];
    return videoFileExtensions.includes(image_type);
}

function MyImageComponent(props) {

    const {item, handleImageClick, isDownloading, isReadOnly, deleteImage} = props


    const [isLoading, setIsLoading] = useState(false)

    let srcList = [item.thumbnail_url, item.download_url, '/loading.gif']
    if (!isImageFile(item.image_type)) {
        if (isDownloading) {
            srcList = ['/loading.gif']
        } else {
            if (isVideoFile(item.image_type)) {
                srcList = ['/video.png']
            } else {
                srcList = ['/attachment.png']
            }
        }
    }

    const {src, isLoadingImage} = useImage({
        srcList: srcList
    })

    function handleOnDelete(item) {
        deleteImage(item.id)
        removeImage(item).then(response => {
            if (!response.ok) {
                console.error('Failed to delete the image on the backend.');
                // Optionally, reload images from the backend or display an error message
            }
        }).catch(error => {
            console.error('Error deleting the image:', error);
        });

    }


    return (

        <div style={{position: 'relative'}}>
            {isLoadingImage ? 'Loading...' :
                <div style={{textAlign: 'center'}}>
                    <img
                        src={src}
                        alt="Image"
                        width={100}
                        height={100}
                        onClick={() => {
                            handleImageClick();
                        }}
                        style={{cursor: isLoading ? 'disabled' : 'pointer'}}
                    />
                    {/*<div style={{marginTop: 5, width: 120,}}> /!* Adjust marginTop as needed *!/*/}
                    {/*    {item.title}*/}
                    {/*</div>*/}
                </div>}
            {!isReadOnly &&
                <span
                    style={{
                        position: 'absolute',
                        top: '0px',
                        right: '5px',
                        cursor: 'pointer',
                        color: 'red',
                        fontSize: '20px',
                        zIndex: 1,
                    }}
                    onClick={() => handleOnDelete(item)} // Assuming the item has an ID property
                >
        &#10007;
      </span>}
        </div>
    )
}

export default function ImageComponent(props) {
    const {item, deleteImage} = props;
    const [showDialog, setShowDialog] = useState(false);
    // const isLoading = useSelector((state) => state.loading.backend)
    const [isLoading, setIsLoading] = useState(false)
    const [isDownloading, setIsDownloading] = useState(false)


    async function handleImageClick() {
        if (isLoading) return


        if (isImageFile(item.image_type)) {
            toggleDialog()
        } else {
            setIsDownloading(true)
            const title = item.title || 'untitled';
            const response = await fetch(item.download_url);
            const blob = await response.blob();
            fileDownload(blob, title);
            setIsDownloading(false)
        }


    }

    const toggleDialog = () => {
        setShowDialog((prevState) => !prevState);
    };

    return (
        <>
            <Suspense>
                <MyImageComponent handleImageClick={handleImageClick} item={item}
                                  deleteImage={deleteImage}
                                  isReadOnly={true}
                                  isDownloading={isDownloading}{...props}/>
            </Suspense>
            <Modal show={showDialog} onHide={toggleDialog} onClick={toggleDialog}>
                <img src={item.download_url} alt="Enlarged Image" style={{width: '100%'}}/>
                {/*<IconButton*/}
                {/*    aria-label="close"*/}
                {/*    onClick={toggleDialog}*/}
                {/*    style={{position: 'absolute', top: '10px', right: '10px', color: '#fff'}}*/}
                {/*>*/}
                {/*    <CloseIcon/>*/}
                {/*</IconButton>*/}
            </Modal>
        </>

    )
}
